import { Profile } from '@app/domain/model/Profile';
import { createContext } from 'react';

export const ProfileContext = createContext<Profile | null>(null);
